/* unplugin-vue-components disabled */
import BuilderInputs from 'components/builder/builder-inputs.vue'
import {MAX_OUTPUT_FIELDS, makeOutputFieldSchema} from './test-agents-defs'

const emptyOutput = () => ({
  name: '',
  type: undefined,
  optional: false,
  description: ''
})

export default {
  components: {BuilderInputs},
  props: {
    entries: {type: Array, required: true}
  },
  emits: ['submit'],
  data() {
    return {
      fields: emptyOutput(),
      schema: makeOutputFieldSchema(this.validateName),
      valid: false,
      index: undefined,
    }
  },
  computed: {
    editing() {
      return this.index !== undefined
    },
    has_diff() {
      if (!this.editing) return true
      const original = this.entries[this.index]
      return !$utils.object.same(this.draft(), original)
    },
    can_save() {
      return this.has_diff && this.valid &&
        (this.editing || this.entries.length < MAX_OUTPUT_FIELDS)
    }
  },
  methods: {
    draft() {
      return {...this.fields}
    },
    validateName(value) {
      const has_name = this.entries.some((entry, idx) => idx !== this.index && entry.name.trim() === value?.trim())
      if (has_name) return 'An output field with this name already exists.'
      return true
    },
    open(entry, index) {
      this.fields = {...emptyOutput(), ...entry}
      this.index = index
      this.$refs.modal.open()
      this.$nextTick(() => this.$refs.fields.$el.querySelector('input')?.focus())
    },
    close() {
      this.$refs.modal.close()
    },
    submit() {
      if (!this.can_save) return
      this.$emit('submit', this.draft(), this.index)
      this.close()
    }
  }
}
